<div class="glass">
  <ng-content></ng-content>
</div>

